import {CanDeleteResult} from '@deviceinsight/ng-ui-scale-lib/api';
import {Bundle, BundleVersion, Pageable} from '@deviceinsight/ng-ui-api-client';
import {searchAllJobs} from '../../../api/updateJobsApi';
import {UpdateJob} from '../types';
import i18next from 'i18next';

const getCanDeleteResult = (pageable: Pageable<UpdateJob>, translation: string) => {
	const canBeDeleted = pageable.totalElements === 0;
	return {
		canBeDeleted,
		error: canBeDeleted ? undefined : translation
	};
};

export const isBundleInUse = ({id: bundleId, name}: Bundle): Promise<CanDeleteResult> =>
	searchAllJobs({
		bundleId
	}).then((pageable) =>
		getCanDeleteResult(
			pageable,
			i18next
				.t('rafi.bundleDelete.customError', {
					name,
					defaultValue: 'The bundle <strong>${name}</strong> cannot be deleted, because jobs depend on it'
				})
				.toString()
		)
	);
export const isBundleVersionInUse = (_: Bundle, {id: bundleVersionId, name}: BundleVersion): Promise<CanDeleteResult> =>
	searchAllJobs({
		bundleVersionId
	}).then((pageable) =>
		getCanDeleteResult(
			pageable,
			i18next
				.t('rafi.bundleVersionDelete.customError', {
					name,
					defaultValue:
						'The bundle version <strong>${name}</strong> cannot be deleted, because jobs depend on it'
				})
				.toString()
		)
	);
